import { useLocation } from 'react-router-dom';

/**
 * Custom hook để làm sạch URL bằng cách xóa các query parameters cụ thể.
 * @param {string[]} keysToRemove - Danh sách các query parameters cần xóa.
 * @returns {function} - Hàm trả về URL đã làm sạch.
 */
export const useCleanUrl = (keysToRemove = []) => {
  const location = useLocation();

  // Hàm trả về URL đã được làm sạch
  const getCleanUrl = () => {
    const { pathname } = location;
    const params = new URLSearchParams(location.search || '');

    // Xóa các query parameters được chỉ định
    keysToRemove.forEach((key) => params.delete(key));

    const cleanQuery = params.toString();
    return cleanQuery ? `${pathname}?${cleanQuery}` : pathname;
  };

  return getCleanUrl;
};
